// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_vfozS","secondaryColumnCell":"secondary-column-cell_vfozS","field":"field_gbcfF","label":"label_hn_na"};